// extracted by mini-css-extract-plugin
var _1 = "AIButtonIconFlat-moduleaiButtonIconFlat__x_yP1 AIButtonIcon-moduleaiButtonIcon__WNIqX";
export { _1 as "aiButtonIconFlat" }
